'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct1 from "./scala.-Product1.js";
var $p;
/** @constructor */
function $c_T1(_1) {
  this.mn = null;
  this.mn = _1;
}
export { $c_T1 as $c_T1 };
$p = $c_T1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T1;
/** @constructor */
function $h_T1() {
}
export { $h_T1 as $h_T1 };
$h_T1.prototype = $p;
$p.n = (function() {
  return 1;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct1.$f_s_Product1__productElement__I__O(this, n);
});
$p.b = (function() {
  return (("(" + this.mn) + ")");
});
$p.o = (function() {
  return "Tuple1";
});
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_sr_ScalaRunTime$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 1228477340, true);
});
$p.f = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T1) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mn, x$1.mn)));
});
function $isArrayOf_T1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ey)));
}
export { $isArrayOf_T1 as $isArrayOf_T1 };
var $d_T1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T1, "scala.Tuple1", ({
  ey: 1,
  rH: 1,
  c: 1,
  b: 1,
  a: 1
}));
export { $d_T1 as $d_T1 };
